/* 请求接口地址管理 */
export var IP =
  process.env.NODE_ENV === "development"
    ? "/proxy-server" //本地代理
    : "https://doujihui-api.bboycc.cn";

// export var IP = "http://124.222.15.81:6688";
